export enum HouseholdEndpoints {
    GetBuildings = "insureds/:userIdentity/insurances/home/policies/:policyId/homes",
    GetInfo = "insureds/:userIdentity/insurances/all/policies/:policyId/info",
}
